import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import * as constants from '../../../utils/constants';
import * as toastService from '../../../services/toastService';

class MUTPhotograpicRecord extends Form {
	state = {
		data: { images: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialImages: PropTypes.array,
		onProceed: PropTypes.func,
	};

	schema = {
		images: Joi.array().min(2).max(constants.IMAGE_LIMITS.GENERAL_PHOTOS).required().label('Images'),
	};

	componentDidMount() {
		if (this.props.initialImages.length > 0) {
			this.setState({ data: { images: this.props.initialImages}})
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.images);
		toastService.success('Photo Record Updated!')
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: constants.IMAGE_LIMITS.GENERAL_PHOTOS,
					multiple: constants.IMAGE_LIMITS.GENERAL_PHOTOS > 1,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'Images',
					sublabel: 'Upload Photograpic Data',
					types: utils.getFileUploadTypes(),
					enforceImageCaptionUpdate: true
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default MUTPhotograpicRecord;
